import { AdminMessage } from "@components/atoms/AdminMessage"
import { BackButton } from "@components/atoms/BackButton"
import { Chip } from "@components/atoms/Chip"
import { ColourTheme } from "@components/atoms/ColourTheme"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Appear } from "@components/motion/Appear"
import { getTranslation } from "@utils/Translations"
import { cn } from "@utils/tw"
import dayjs from "dayjs"
import { defineBlock, EditableText, usePostTitleEditor } from "eddev/blocks"
import { Link } from "eddev/routing"

export const meta: BlockMeta = {
  title: "Press Header",
  postMetaBlock: {
    postTypes: ["press"],
    fieldName: "headerData",
  },
}

export default defineBlock("section/press-header", (props) => {
  const tags = props.tags || []
  const authors = props.authorPage || props.authorText ? [{ title: props.authorText, uri: null }] : []

  return (
    <Appear className={cn("press-header contents relative")}>
      <ColourTheme
        theme={props.colourTheme || props.defaultColour}
        className="absolute w-full top-0 left-0 h-navBarInnerTopBase"
      />
      <ColourTheme theme={props.colourTheme || props.defaultColour} className="w-full relative -mt-1">
        <div className="pb-9 md:py-9 px-6 w-maxContentW mx-auto flex flex-col gap-7 md:gap-4">
          <BackButton href="/press">{getTranslation("backToPress", "Back to press")}</BackButton>
          <div className="w-full max-w-blogPostVideoW mx-auto flex flex-col gap-8 md:gap-7 items-center">
            <div className="flex gap-2 items-center">
              {props.category && <Chip>{props.category.name}</Chip>}
              {tags.length > 0 &&
                tags.map(
                  (tag) =>
                    !!tag && (
                      <Chip key={tag.slug} square>
                        {tag.name}
                      </Chip>
                    ),
                )}
            </div>
            <h1 className="type-header-2-xl text-center">
              {env.admin ? (
                <EditableText store={usePostTitleEditor()} as="span" placeholder="Enter title" />
              ) : (
                <span dangerouslySetInnerHTML={{ __html: props.press?.title || "" }} />
              )}
            </h1>
            <p className="type-ui-label flex items-center gap-2">
              {authors.length > 0 && (
                <>
                  <span>
                    {authors.map(
                      (a, ax) =>
                        a.title && (
                          <>
                            <Link key={a.title} href={a.uri}>
                              {a.title}
                            </Link>
                            {ax < authors.length - 1 && <span>, </span>}
                          </>
                        ),
                    )}
                  </span>
                  <span>・</span>
                </>
              )}
              <span>{dayjs(props.press?.date).format("MMM DD YYYY")}</span>
              {props.press?.readTime && (
                <>
                  <span>・</span>
                  <span>{props.press.readTime}</span>
                </>
              )}
            </p>
            <div className="w-blogPostFeaturedW shrink-0">
              {props.press?.featuredImage?.node ? (
                <ResponsiveImage
                  {...props.press.featuredImage.node}
                  className="w-full h-auto rounded-md overflow-hidden"
                />
              ) : (
                <AdminMessage>
                  Set a featured image for this post.
                  <br />
                  Refresh once added to view here.
                </AdminMessage>
              )}
            </div>
          </div>
        </div>
      </ColourTheme>
    </Appear>
  )
})
